
// Locallly Data Api

// export const Api_Url = "https://uatapi.rohahousing.org/"

// Production Data Api 

export const Api_Url = "https://api.rohahousing.org/"
// 
// export const Api_Url = "https://localhost:7060/"